import { StyledTwitterTweet as TwitterTweet } from '../../../components/TwitterTweet.jsx';

export const mapTwitterPlaceholderToTwitterComponent = matchedElem => {
  const tweetId = matchedElem.dataset.id;

  return (
    <TwitterTweet tweetId={tweetId} />
  );
};
